module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/sec04_sp_a9951914c13563c614e28ce4e517f36a.jpg";